import "//shopakaso.com/cdn/shop/t/25/assets/swiper@11.min.js?v=104684603862494721831780911930"
import "//shopakaso.com/cdn/shop/t/25/assets/jquery.js?v=147293088974801289311780911872"

// 入口函数，在页面加载完成后执行
function main() {
    Alpine.data('storeCameramb', function () {
        const el = $(this);
        return {
            swiperOptionSeven: {
                initialSlide: 0,
                direction: 'horizontal',
                loop: true,
                autoplay: false,
                slidesPerView: 'auto',
                spaceBetween: 8,
                slidesOffsetBefore: 0,
                on: {
                  slideChangeTransitionEnd() {
                    const wst = $(window).scrollTop()
                    const st = wst + 56
                    const q = $('.store-action-camera').offset().top
                    if (st > q) {
                      $('.store-action-camera-product-img').show()
                      $('.store-action-camera-product-recording').hide()
                      $('.swiper-slide-active')
                        .find('.store-action-camera-product-img')
                        .hide()
                      $('.swiper-slide-active')
                        .find('.store-action-camera-product-recording')
                        .show()
                    }
                  },
                },
            },
            localName: window.Shopify.locale,
            init() {
                $(function () {
                    /* 滑动效果 */
                    $(window).scroll(function (event) {
                        const wst = $(window).scrollTop()
                        const st = wst + 56
                        const q = $('.store-action-camera-mb').offset().top
                        if (st > q) {
                          $('.store-action-camera-product-img-one-mb').hide()
                          $('.store-action-camera-product-recording-one-mb').show()
                        }
                    })
                    /* 滑动效果 */
                })
                this.initMB()
            }, // end init
            initMB() {
                this.initMBSwiper()
            },
            initMBSwiper() {
                new Swiper('.swiper-container-action-mb', this.swiperOptionSeven)
            },
        }
    })
}
document.addEventListener('alpine:init', main)